export default function ProductCardSkeleton() {
  return (
    <div className="product-col mb-3 mb-md-3 mb-xl-4">
      <div className={`card product-card h-100 position-relative pt-4`}>
        <div className="price-display position-absolute rounded fw-600" style={{ width: '75px' }}>
          <span className="animated-placeholder opacity-0"></span>
        </div>
        <div className="card-body">
          <h3 className="fs-5 card-title text-theme-primary">
            <span className="animated-placeholder height-md w-90"></span>
          </h3>
          <div className="description-wrap">
            <span className="animated-placeholder"></span>
            <span className="animated-placeholder w-90"></span>
            <span className="animated-placeholder w-70"></span>
          </div>
        </div>
        <div className="card-footer bg-transparent border-0 pb-3 d-flex justify-content-between align-items-center">
          <button className={`add-to-cart-btn btn btn-outline-secondary fw-600`} disabled type="button">
            Add to Cart
          </button>
          <span className="d-block text-muted me-xxl-2" style={{ width: '80px' }}>
            <span className="animated-placeholder height-sm"></span>
          </span>
        </div>
      </div>
    </div>
  );
}
